import React from 'react';
import { graphql } from 'gatsby';

import { default as PricingDetailsSectionDS } from 'design-system/src/components/organisms/PricingDetailsSection';

export default function PricingDetailsSection({
    cols,
    matrixContent,
    ...props
}: any) {
    return (
        <PricingDetailsSectionDS
            {...props}
            content={matrixContent}
            cols={['', ...cols.map((col: any) => col.title)]}
        />
    );
}

export const query = graphql`
    fragment DatoCmsPricingDetailsTable on DatoCmsPricingDetailsTable {
        toggleButtonOpen
        toggleButtonClose
        toggleButtonMobile
        collapsed
        cols {
            title
            cta {
                ...Button
            }
        }
        matrixContent {
            label
            href
        }
    }
`;
